import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker (production build only — see the module). This
// enables installability (Android/Chrome prompt, TWA) and an offline app shell.
// Auth/data (Supabase, Edge Functions) are network-only inside the SW.
serviceWorkerRegistration.register();

// Auto-refresh once when a NEW deployed SW takes control, so a fresh deploy is
// never masked by the already-loaded (cached) bundle. The SW uses
// skipWaiting + clients.claim, so a new version activates and claims the page on
// the next load; without this, the open tab keeps running the OLD bundle until a
// manual reload (the recurring "deployed but not showing" staleness).
//
// Loop-safe: we only attach when a controller ALREADY exists at load (i.e. a
// returning visitor whose controller is being REPLACED = a real update), never on
// the first-ever install (no controller yet), and the `refreshing` flag reloads
// exactly once.
if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
